import { createAction } from '@reduxjs/toolkit'
import type { IFetchHistoryPayload, IRequestHistoryFailedPayload, IRequestHistoryFinishedPayload } from './interfaces'

export const fetchHistory = createAction<IFetchHistoryPayload>('@@history/FETCH_HISTORY')
export const onHistoryRequestFinished = createAction<IRequestHistoryFinishedPayload>('@@history/REQUEST_FINISHED')
export const onHistoryRequestFailed = createAction<IRequestHistoryFailedPayload>('@@history/REQUEST_FAILED')
export const reloadHistory = createAction<IFetchHistoryPayload>('@@history/RELOAD_HISTORY')
